module.exports = __webpack_public_path__ + "static/img/estandarizada.1260b3ee.png";